import { useMemo } from 'react';
import { useLazyHook } from './useLazyHook';
export var useLazyDataManager = function (getImportFunction, managerType, managerProps) {
    var dataManagerModule = useLazyHook(getImportFunction(managerType));
    return useMemo(function () {
        return dataManagerModule && managerProps
            ? dataManagerModule.getDataManager(managerProps)
            : undefined;
    }, [managerProps, dataManagerModule]);
};
//# sourceMappingURL=useLazyDataManager.js.map